<div #wrapper [ngClass]="wrapperClasses" [style.max-height.px]="scrollMaxHeightPx">
  <ng-content></ng-content>
</div>
